module.exports = __webpack_public_path__ + "img/cloudy.bcb3e123.svg";